<template>
    <div class="join__navigation">
        <a :href="'mailto:' + requestMailto" class="button join__button">
            <span class="button__text">{{ $t('buttons.request_footer') }} →</span>
        </a>
        <router-link :to="{name: ((this.$i18n.locale == this.mainLang)? '' : this.$i18n.locale+'.') + 'contact', params: { locale: ((this.$i18n.locale == this.mainLang)? '' : '/' + this.$i18n.locale) }}" class="button button_gray join__button">
            <span class="button__text">{{ $t('buttons.contacts') }} →</span>
        </router-link>
    </div>
</template>

<script>
    import params from '../../public/site_config.json'
    import i18n from '../lang/lang'
    
    export default {
        data() {
            return {
                mainLang: params.initial_lang,
                requestMailto: params.reauest_quote_emailto
            }
        },
        methods: {
            
        }
    }
</script>

<style scoped lang="stylus">
    .join__button
        margin 40px 40px 0 0
        font-size 14px
        font-weight 600
        &:not(:last-child)
            margin-bottom 20px

            @media (min-width 400px)
                margin-bottom 0

        &:last-child
            @media (min-width 400px)
                margin-right 0
</style>